import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Button } from "../../../../../../components/Form";

export const DownloadButton = styled(Button)(() => ({
  whiteSpace: "nowrap",
}));

export const ExportCSVButton = styled(Button)(() => ({
  width: 135,
}));

export const EmptyDiv = styled("div")(() => ({
  border: "1px solid #eaebef",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  borderRadius: "5px",
  textAlign: "center",
  minHeight: "calc(100vh - 390px)",
}));

export const RightActionsGrid = styled(Grid)(() => ({
  width: "max-content",
  marginTop: "28px",
}));

export const LeftActionsGrid = styled(Grid)(() => ({
  minWidth: "240px",
}));
